import { capitalize } from 'lodash';

export function getEditorId(containerId) {
  return `editor${capitalize(containerId)}`;
}

/**
 *
 * @param ctrls 所有组件信息
 * @param key 正解析的节点键值
 * @param inServiceNodes 使用中的节点
 * @param result 最后保存时所需的键
 *
 */
export function removeCtrl(ctrls, key, inServiceNodes, result) {
  const keyRecord = key || 'ctrl-root';
  const inServiceNodesRecord = inServiceNodes || ['ctrl-root'];
  const resultRecord = result || {};

  if (ctrls[keyRecord].children) {
    for (const childKey of ctrls[keyRecord].children) {
      if (ctrls[childKey].children && ctrls[childKey].children.length > 0) {
        inServiceNodesRecord.push(childKey);
        removeCtrl(ctrls, childKey, inServiceNodesRecord, resultRecord);
      } else {
        inServiceNodesRecord.push(childKey);
      }
    }
  } else {
    return inServiceNodesRecord.push(keyRecord);
  }


  for (const inServiceKey of inServiceNodesRecord) {
    resultRecord[inServiceKey] = ctrls[inServiceKey];
  }

  return resultRecord;
}

export function getTypeByInstance(instance) {
  if (_.get(instance, 'props.ctrl.type') === 'Container') {
    return _.get(instance, 'props.ctrl.componentType', '');
  } else {
    return _.get(instance, 'props.ctrl.type', '');
  }
}

/**
 * 计算栅格布局内列的比例
 * @param {number} num 列数
 */
export function calcColWidth(num) {
  const total = 24;
  let resultNum = 1;
  let residue = 0;
  const result = [];
  if (num > 24 || +num === 0) {
    resultNum = 1;
  } else if ((total / num) % 1 !== 0) {
    while (resultNum * num < total) {
      resultNum += 1;
    }
    resultNum -= 1;
    residue = total - (resultNum * num);
  } else {
    resultNum = total / num;
  }
  for (let i = 0; i < num; i += 1) {
    if (i < residue) {
      result[i] = resultNum + 1;
    } else {
      result[i] = resultNum;
    }
  }
  return result;
}

/**
 * 判断是否被人联动了初始化
 * @param {Object} proxy 代理数据
 * @param {String} id 该组件ID
 */
export function isOnLoadProxy(proxy, id) {
  let result = false;
  if (!proxy) return;
  Object.values(proxy).forEach((source) => {
    if (source.onload) {
      Object.values(source.onload).forEach((item) => {
        if (item.id === id) {
          result = true;
        }
      });
    }
  });
  return result;
}
